/* InsCoder WANG.J 2026-10-06 B + Enhance collection labels and load trusted source-ring enquiries. */
(() => {
  'use strict';
  const config = document.currentScript;
  const sapphireCollections = ['sapphire-engagement-rings'];

  function enhanceCollection() {
    if (!config || !sapphireCollections.includes(config.dataset.collection)) return;
    const root = document.getElementById('CollectionSection');
    if (!root || root.dataset.customMakeEnhanced) return;
    root.dataset.customMakeEnhanced = 'true';
    function updateTags() {
      root.querySelectorAll('.enquire-now, .grid-product__tag--sold-out').forEach(tag => {
        if (tag.classList.contains('grid-product__tag--custom')) return;
        if (tag.textContent !== config.dataset.label) tag.textContent = config.dataset.label;
        tag.classList.add('cust-custom-make-tag');
        const card = tag.closest('.grid-product, .list-view-item');
        card?.querySelector('.grid-product__link--disabled')?.classList.remove('grid-product__link--disabled');
      });
    }
    updateTags();
    const observer = new MutationObserver(updateTags);
    observer.observe(root, { childList: true, subtree: true });
    root.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link || event.target.closest('button, .quick-product__btn')) return;
      const card = link.closest('.grid-product, .list-view-item');
      if (card?.querySelector('.cust-custom-make-tag')) event.stopImmediatePropagation();
    }, true);
    function unload(event) {
      if (!event.target.contains(root)) return;
      observer.disconnect();
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
  }

  function ringSpecs(description) {
    const doc = new DOMParser().parseFromString(description, 'text/html');
    doc.querySelectorAll('br').forEach(br => br.replaceWith('\n'));
    doc.querySelectorAll('p, li, div').forEach(row => row.append('\n'));
    return doc.body.textContent.split('\n').map(text => text.trim())
      .filter(text => /^(metal|sapphire|(?:side\s+)?diamonds?)\s*:/i.test(text))
      .map(text => text.replace(/^(metal|sapphire|(?:side\s+)?diamonds?)\s*:\s*/i, ''))
      .filter((text, index, values) => text && values.indexOf(text) === index)
      .join(' · ');
  }

  class CustomMakeEnquiry extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      const params = new URLSearchParams(window.location.search);
      const handle = params.get('custom_make');
      if (!handle) return;
      const status = this.querySelector('[data-custom-make-status]');
      if (!/^[a-z0-9][a-z0-9-]*$/.test(handle) || handle.length > 255) {
        status.textContent = this.dataset.error;
        status.hidden = false;
        return;
      }
      this.controller = new AbortController();
      status.textContent = this.dataset.loading;
      status.hidden = false;
      this.loadRing(handle, params).catch(error => {
        if (error.name === 'AbortError') return;
        status.textContent = this.dataset.error;
        status.hidden = false;
      });
    }

    disconnectedCallback() { this.controller?.abort(); this.loaded = false; }

    async loadRing(handle, params) {
      const endpoint = new URL(`${this.dataset.root}products/${encodeURIComponent(handle)}`, window.location.origin);
      endpoint.searchParams.set('view', 'custom-make');
      const variant = params.get('variant');
      if (variant && /^\d+$/.test(variant)) endpoint.searchParams.set('variant', variant);
      const response = await fetch(endpoint, { signal: this.controller.signal });
      if (!response.ok) throw new Error('Ring unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = doc.querySelector('[data-custom-make-source]');
      if (!source || source.dataset.productHandle !== handle) throw new Error('Invalid ring');
      const card = source.querySelector('[data-custom-make-card]');
      const fields = source.querySelector('[data-custom-make-fields]');
      const enquiry = this.querySelector('[data-custom-make-enquiry]');
      const form = enquiry?.querySelector('form');
      if (!card || !fields || !form) throw new Error('Enquiry unavailable');
      const specs = ringSpecs(source.dataset.ringDescription || '');
      if (specs) {
        card.querySelector('[data-custom-make-specs]').textContent = specs;
        card.querySelector('[data-custom-make-specs]').hidden = false;
      }
      fields.querySelector('[data-custom-make-specs-input]').value = specs;
      const returnTo = new URL(window.location.pathname, window.location.origin);
      returnTo.searchParams.set('custom_make', handle);
      returnTo.searchParams.set('variant', fields.querySelector('[name="contact[ring variant]"]').value);
      returnTo.hash = form.id;
      form.querySelector('[name="return_to"]').value = returnTo.pathname + returnTo.search + returnTo.hash;
      card.querySelector('h2').id = `${form.id}-ring`;
      card.setAttribute('aria-labelledby', `${form.id}-ring`);
      this.querySelector('[data-custom-make-ring-slot]').replaceChildren(card);
      this.querySelector('[data-custom-make-enquiry-fields]').replaceChildren(...fields.children);
      this.querySelector('[data-custom-make-original]').hidden = true;
      enquiry.hidden = false;
      this.querySelector('[data-custom-make-status]').hidden = true;
    }
  }

  if (!customElements.get('custom-make-enquiry')) customElements.define('custom-make-enquiry', CustomMakeEnquiry);
  enhanceCollection();
  document.addEventListener('shopify:section:load', enhanceCollection);
  document.addEventListener('variant:change', event => {
    const variant = event.detail?.variant;
    if (!variant || !/^\d+$/.test(String(variant.id))) return;
    document.querySelectorAll('.cust-custom-make-product').forEach(form => {
      if (!form.querySelector(`[data-product-select] option[value="${variant.id}"]`)) return;
      const link = form.querySelector('[data-custom-make-link]');
      const url = new URL(link.href);
      url.searchParams.set('variant', variant.id);
      link.href = url.href;
    });
  });
})();
/* InsCoder WANG.J 2026-10-06 E + Enhance collection labels and load trusted source-ring enquiries. */
